<template>
  <div id="mainContent" class="scene-detail content">

    <!-- 日期选择器 -->
    <el-row :gutter="40" style="margin: 20px 0 0 0;">
      <el-col :xs="24" :sm="24" :lg="24" style="padding:20px;background:white;position:relative;">
        <div class="searchWarp">
          <!-- 公司选择 -->
          <el-date-picker v-model="searchObj.selectDate" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch" />
          <el-input style="display: none;" v-model="searchObj.sn" :placeholder="$t('liBattery.DeviceName')" class="input-with-select deviceNameTable" clearable @clear="changeSearch">
            <el-button slot="append" icon="el-icon-search" @click="changeSearch" />
          </el-input>
        </div>
        <el-button icon="el-icon-download" size="mini" style="vertical-align: top;margin:5px 10px;float: right;position: relative;z-index: 999;" type="primary" @click="download" />
        <el-tabs v-model="activeTab" type="border-card">
          <el-tab-pane :label="$t('liBattery.BaseInfo')" name="baseInfoPane" style="position:relative;">
              <el-table :data="baseInfoList" border style="width: auto" fit class="myTable">
                <el-table-column type="expand" style="border-right: none;">
                  <template slot-scope="scope">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.productionDate')">
                          <span>{{ scope.row.productionDate }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.capacity')">
                          <span>{{ scope.row.capacity }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.remainCapacity')">
                          <span>{{ scope.row.remainCapacity }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.cell')">
                          <span>{{ scope.row.cell }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.version')">
                          <span>{{ scope.row.version }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.cycles')">
                          <span>{{ scope.row.cycles }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.ntc')">
                          <span>{{ scope.row.ntc }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.ntcs')">
                          <span>{{ scope.row.ntcsStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.ChargeSwitch')">
                          <span>{{ scope.row.chargeSwitch }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.DischargeSwitch')">
                          <span>{{ scope.row.dischargeSwitch }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.balances')">
                          <span>{{ scope.row.balanceStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.cellOvervoltageProtect')">
                          <span>{{ scope.row.cellOvervoltageProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.cellUndervoltageProtect')">
                          <span>{{ scope.row.cellUndervoltageProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.overvoltageProtect')">
                          <span>{{ scope.row.overvoltageProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.undervoltageProtect')">
                          <span>{{ scope.row.undervoltageProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.chargingHighTempProtect')">
                          <span>{{ scope.row.chargingHighTempProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.chargingLowTempProtect')">
                          <span>{{ scope.row.chargingLowTempProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.dischargingHighTempProtect')">
                          <span>{{ scope.row.dischargingHighTempProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.dischargingLowTempProtect')">
                          <span>{{ scope.row.dischargingLowTempProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.chargOvercurrentProtect')">
                          <span>{{ scope.row.chargOvercurrentProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.dischargOvercurrentProtect')">
                          <span>{{ scope.row.dischargOvercurrentProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.shortProtectionProtect')">
                          <span>{{ scope.row.shortProtectionProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.frontEndEetectionICErrorProtect')">
                          <span>{{ scope.row.frontEndEetectionICErrorProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.softwareLockMOSProtect')">
                          <span>{{ scope.row.softwareLockMOSProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.chargingMOSBreakdownMarkProtect')">
                          <span>{{ scope.row.chargingMOSBreakdownMarkProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.dischargeMOSBreakdownMarkProtect')">
                          <span>{{ scope.row.dischargeMOSBreakdownMarkProtectSwitchStr }}</span>
                        </el-form-item>
                      </el-col>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('liBattery.DeviceName')" prop="name" align="center" />
                <el-table-column :label="$t('kisae.CreatedAt')" prop="CreatedAt" align="center" />
                <el-table-column :label="$t('kisae.SOC')+'(%)'" prop="rsoc" align="center" />
                <el-table-column :label="$t('kisae.Current')+'(A)'" prop="current" align="center" />
                <el-table-column :label="$t('kisae.Voltage')+'(V)'" prop="voltage" align="center" />
                <el-table-column width="200" :label="$t('QR.Uploader')" prop="createBy" align="center" />
              </el-table>
              <!-- 列表模块————分页 -->
              <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
                <div class="pagination-container">
                  <el-pagination
                    v-if="pageshow"
                    background
                    current-page.sync="baseInfoQuery.pageInfo.page"
                    :page-sizes="baseInfoQuery.pageInfo.pageList"
                    :page-size="baseInfoQuery.pageInfo.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="baseInfoQuery.pageInfo.total"
                    @size-change="handleBaseInfoSizeChange"
                    @current-change="handleBaseInfoCurrentChange"
                  />
                </div>
              </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('liBattery.CellVoltageData')" name="cellVoltagePane" style="position:relative;">
              <el-table :data="cellVoltageList" border style="width: auto" fit class="myTable">
                <el-table-column :label="$t('liBattery.DeviceName')" prop="name" align="center" />
                <el-table-column :label="$t('liBattery.CreatedAt')" prop="CreatedAt" align="center" />
                <el-table-column width="600" :label="$t('liBattery.CellVoltage')" prop="list" align="center" />
                <el-table-column :label="$t('QR.Uploader')" prop="createBy" align="center" />
              </el-table>
              <!-- 列表模块————分页 -->
              <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
                <div class="pagination-container">
                  <el-pagination
                    v-if="pageshow"
                    background
                    current-page.sync="cellVoltageQuery.pageInfo.page"
                    :page-sizes="cellVoltageQuery.pageInfo.pageList"
                    :page-size="cellVoltageQuery.pageInfo.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="cellVoltageQuery.pageInfo.total"
                    @size-change="handleCellVoltageSizeChange"
                    @current-change="handleCellVoltageCurrentChange"
                  />
                </div>
              </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('liBattery.BatteryProtectionStatistic')" name="batteryProtectionPane" style="position:relative;">
              <el-table :data="batteryProtectionList" border style="width: auto" fit class="myTable">
                <el-table-column type="expand" style="border-right: none;">
                  <template slot-scope="scope">
                    <el-form label-position="left" inline class="demo-table-expand">
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.cellOvervoltage')">
                          <span>{{ scope.row.cellOvervoltage }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.cellUndervoltage')">
                          <span>{{ scope.row.cellUndervoltage }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.chargOvercurrent')">
                          <span>{{ scope.row.chargOvercurrent }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.dischargOvercurrent')">
                          <span>{{ scope.row.dischargOvercurrent }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.chargingHighTemp')">
                          <span>{{ scope.row.chargingHighTemp }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.dischargingHighTemp')">
                          <span>{{ scope.row.dischargingHighTemp }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.chargingLowTemp')">
                          <span>{{ scope.row.chargingLowTemp }}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="12" :sm="12" :lg="8">
                        <el-form-item :label="$t('liBattery.dischargingLowTemp')">
                          <span>{{ scope.row.dischargingLowTemp }}</span>
                        </el-form-item>
                      </el-col>

                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('liBattery.DeviceName')" prop="name" align="center" />
                <el-table-column :label="$t('liBattery.CreatedAt')" prop="CreatedAt" align="center" />
                <el-table-column :label="$t('liBattery.overvoltage')" prop="overvoltage" align="center" />
                <el-table-column :label="$t('liBattery.undervoltage')" prop="undervoltage" align="center" />
                <el-table-column :label="$t('liBattery.shortProtection')" prop="shortProtection" align="center" />
                <el-table-column :label="$t('liBattery.restart')" prop="restart" align="center" />
                <el-table-column width="200" :label="$t('QR.Uploader')" prop="createBy" align="center" />
              </el-table>
              <!-- 列表模块————分页 -->
              <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
                <div class="pagination-container">
                  <el-pagination
                    v-if="pageshow"
                    background
                    current-page.sync="batteryProtectionQuery.pageInfo.page"
                    :page-sizes="batteryProtectionQuery.pageInfo.pageList"
                    :page-size="batteryProtectionQuery.pageInfo.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="batteryProtectionQuery.pageInfo.total"
                    @size-change="handleBatteryProtectionSizeChange"
                    @current-change="handleBatteryProtectionCurrentChange"
                  />
                </div>
              </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { pageBluetoothData } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime'
import { temUnit, temChange, temChangeUnit } from '@/utils/temChange'
import i18n from '@/i18n'
import store from '@/store'

export default {
  data() {
    return {
      // 分页----start
      baseInfoQuery: {
        pageInfo: pagination()
      },
      cellVoltageQuery: {
        pageInfo: pagination()
      },
      batteryProtectionQuery:{
        pageInfo: pagination()
      },
      pageshow: true,
      // 分页----end
      basicinfo: {},
      searchObj: {
        sn: '',
        selectDate: [new Date().setHours(0, 0, 0, 0) - 6 * 24 * 60 * 60 * 1000, new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1000] // 默认一周
      },
      activeTab: 'baseInfoPane',
      baseInfoList: [],
      cellVoltageList: [],
      batteryProtectionList: [],
      lineHeight: '600px',
      batteryProtectionStrList: [],
    }
  },
  watch: {
/*    activeTab(newValue, oldValue) {
      if (newValue == 'baseInfoPane') {
        this.queryBaseInfo()// 获取基本信息
      } else if (newValue == 'cellVoltagePane') {
        this.queryCellVoltageData()// 获取电芯电压数据
      }
    } */
  },
  mounted() {
    this.searchObj.sn = this.$route.query.name

    this.queryBaseInfo() //获取基本信息
    this.queryCellVoltageData() //获取电芯电压数据
    this.queryBatteryProtectionData()  //获取电池保护统计数据
  },
  methods: {
    queryBaseInfo() { // 获取基本信息
      var param = {
        'startDate': new Date(this.searchObj.selectDate[0]).getTime(),
        'endDate': new Date(this.searchObj.selectDate[1]).getTime(),
        // 'mcuId': '001c00115847501420303142',
        'mcuId': this.searchObj.sn,
        pageNum: this.baseInfoQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.baseInfoQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 13
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      pageBluetoothData(param).then(res => { // 基本信息
        this.baseInfoList = []
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.list.forEach(v => {
          var obj = {}
          if (v.jsonData && v.jsonData.indexOf('{') > -1) obj = JSON.parse(v.jsonData)
          obj.createBy = v.createBy;
          obj.createTime = v.createTime;
          obj.name = v.mcuId;

          let fets = obj.fets;
          let chargeSwitch = (fets && fets[0] && fets[0] == 1) ? true : false;
          let dischargeSwitch = (fets && fets[1] && fets[1] == 1) ? true : false;
          obj.chargeSwitch = chargeSwitch ? i18n.t('liBattery.On') : i18n.t('liBattery.Off');
          obj.dischargeSwitch = dischargeSwitch ? i18n.t('liBattery.On') : i18n.t('liBattery.Off');

          let ntcs = obj.ntcs;
          if(ntcs){
            let ntcsTemp = []
            ntcs.forEach(ntc => {
              ntcsTemp.push(temChangeUnit(ntc));
            })
            obj.ntcsStr = ntcsTemp.join(', ');
          }

          let balances = obj.balances;
          if(balances){
            let balanceTemp = [];
            balances.forEach( (balance,index) => {
              let balanceSwitch = (balance && balance == 1) ? true : false
              let balanceSwitchI18n = balanceSwitch ? i18n.t('liBattery.On') : i18n.t('liBattery.Off');
              balanceTemp.push((index+1) + ":" + balanceSwitchI18n);
            })
            obj.balanceStr = balanceTemp.join(', ');
          }

          // batteryProtectionStrList
          let protections = obj.protections;
          if(protections){
            let protectedStr = i18n.t('liBattery.Protected'), unprotectedStr = i18n.t('liBattery.Unprotected');
            obj.cellOvervoltageProtectSwitchStr = (protections[0] && protections[0]==1) ? protectedStr : unprotectedStr;
            obj.cellUndervoltageProtectSwitchStr = (protections[1] && protections[1]==1) ? protectedStr : unprotectedStr;
            obj.overvoltageProtectSwitchStr = (protections[2] && protections[2]==1) ? protectedStr : unprotectedStr;
            obj.undervoltageProtectSwitchStr = (protections[3] && protections[3]==1) ? protectedStr : unprotectedStr;
            obj.chargingHighTempProtectSwitchStr = (protections[4] && protections[4]==1) ? protectedStr : unprotectedStr;
            obj.chargingLowTempProtectSwitchStr = (protections[5] && protections[5]==1) ? protectedStr : unprotectedStr;
            obj.dischargingHighTempProtectSwitchStr = (protections[6] && protections[6]==1) ? protectedStr : unprotectedStr;
            obj.dischargingLowTempProtectSwitchStr = (protections[7] && protections[7]==1) ? protectedStr : unprotectedStr;
            obj.chargOvercurrentProtectSwitchStr = (protections[8] && protections[8]==1) ? protectedStr : unprotectedStr;
            obj.dischargOvercurrentProtectSwitchStr = (protections[9] && protections[9]==1) ? protectedStr : unprotectedStr;
            obj.shortProtectionProtectSwitchStr = (protections[10] && protections[10]==1) ? protectedStr : unprotectedStr;
            obj.frontEndEetectionICErrorProtectSwitchStr = (protections[11] && protections[11]==1) ? protectedStr : unprotectedStr;
            obj.softwareLockMOSProtectSwitchStr = (protections[12] && protections[12]==1) ? protectedStr : unprotectedStr;
            obj.chargingMOSBreakdownMarkProtectSwitchStr = (protections[13] && protections[13]==1) ? protectedStr : unprotectedStr;
            obj.dischargeMOSBreakdownMarkProtectSwitchStr = (protections[14] && protections[14]==1) ? protectedStr : unprotectedStr;
          }

          this.baseInfoList.push(obj)
        })
       this.baseInfoList.forEach(v => {
          v.CreatedAt = getDateAndHour(v.createTime)
        })
        this.baseInfoQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    queryCellVoltageData() { // 获取电芯电压数据
      var param = {
        'startDate': new Date(this.searchObj.selectDate[0]).getTime(),
        'endDate': new Date(this.searchObj.selectDate[1]).getTime(),
        // 'mcuId': '001c00115847501420303142',
        'mcuId': this.searchObj.sn,
        pageNum: this.cellVoltageQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.cellVoltageQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 14
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      pageBluetoothData(param).then(res => { // 基本信息
        this.cellVoltageList = [];
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.list.forEach(v => {
          var obj = {}
          // if (v.jsonData && v.jsonData.indexOf('{') > -1) obj = JSON.parse(v.jsonData)
          obj.createBy = v.createBy;
          obj.createTime = v.createTime;
          obj.name = v.mcuId;
          obj.list = v.jsonData;
          this.cellVoltageList.push(obj)
        })
        this.cellVoltageList.forEach(v => {
          v.CreatedAt = getDateAndHour(v.createTime)
        })
        console.log(this.cellVoltageList);
        this.cellVoltageQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    queryBatteryProtectionData() { // 获取电池保护统计数据
      var param = {
        'startDate': new Date(this.searchObj.selectDate[0]).getTime(),
        'endDate': new Date(this.searchObj.selectDate[1]).getTime(),
        // 'mcuId': '001c00115847501420303142',
        'mcuId': this.searchObj.sn,
        pageNum: this.batteryProtectionQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.batteryProtectionQuery.pageInfo.pageSize, // 分页--每一页的列表的行数 10 20 50
        'showAll': false,
        'type': 15
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      pageBluetoothData(param).then(res => { // 基本信息
        this.batteryProtectionList = [];
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.list.forEach(v => {
          var obj = {}
          if (v.jsonData && v.jsonData.indexOf('{') > -1) obj = JSON.parse(v.jsonData)
          obj.createBy = v.createBy;
          obj.createTime = v.createTime;
          obj.name = v.mcuId;
          this.batteryProtectionList.push(obj)
        })
        this.batteryProtectionList.forEach(v => {
          v.CreatedAt = getDateAndHour(v.createTime)
        })
        console.log(this.batteryProtectionList);
        this.batteryProtectionQuery.pageInfo.total = res.resultModel.total // 分页
      })
    },
    changeSearch() { // 改变筛选条件
      // if (this.activeTab == 'baseInfoPane') { // 获取广播数据
      //   this.baseInfoQuery.pageInfo.pageNum = 1
      //   this.pageshow = false
      //   this.queryBaseInfo()
      // }
      // if (this.activeTab == 'cellVoltagePane') {
      //   this.cellVoltageQuery.pageInfo.pageNum = 1
      //   this.pageshow = false
      //   this.queryCellVoltageData()// 获取详情数据
      // }
      // if (this.activeTab == 'batteryProtectionPane') {
      //   this.batteryProtectionQuery.pageInfo.pageNum = 1
      //   this.pageshow = false
      //   this.queryBatteryProtectionData()// 获取详情数据
      // }

      this.pageshow = false
      this.baseInfoQuery.pageInfo.pageNum = 1
      this.cellVoltageQuery.pageInfo.pageNum = 1
      this.batteryProtectionQuery.pageInfo.pageNum = 1
      this.queryBaseInfo()
      this.queryCellVoltageData()
      this.queryBatteryProtectionData()

      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    download() { // 下载
    
      let temType = store.state.temType || "ssd";
      let tem = temType === 'ssd' ? 'C' : 'F';
    
      var param = {
        type: '',
        mcuId: this.searchObj.sn,
        startDate: new Date(this.searchObj.selectDate[0]).getTime(),
        endDate: new Date(this.searchObj.selectDate[1]).getTime(),
        lang: this.$i18n.locale
      }
      if (this.searchObj.selectDate.length > 0) {
        param.startDate = new Date(this.searchObj.selectDate[0]).getTime()
        param.endDate = new Date(this.searchObj.selectDate[1]).getTime() + 24 * 60 * 60 * 1000 - 1000
      }
      param.type = 13;
      if(this.activeTab == 'cellVoltagePane'){
        param.type = 14;
      }else if(this.activeTab == 'batteryProtectionPane'){
        param.type = 15;
      }
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportLiBatteryData?mcuId='
      url += param.mcuId + '&type=' + param.type + '&startDate=' + param.startDate + '&endDate=' + param.endDate + 
      '&lang=' + param.lang + '&tem=' + tem
      window.open(url, '_bank')
    },
    // 分页----start
    handleBaseInfoSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.baseInfoQuery.pageInfo.pageSize = val
      this.queryBaseInfo()
    },
    handleBaseInfoCurrentChange(val, e) { // 选中某一页
      this.baseInfoQuery.pageInfo.pageNum = val
      this.queryBaseInfo()
    },
    handleCellVoltageSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.cellVoltageQuery.pageInfo.pageSize = val
      this.queryCellVoltageData()
    },
    handleCellVoltageCurrentChange(val, e) { // 选中某一页
      this.cellVoltageQuery.pageInfo.pageNum = val
      this.queryCellVoltageData()
    },
    handleBatteryProtectionSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.batteryProtectionQuery.pageInfo.pageSize = val
      this.queryBatteryProtectionData()
    },
    handleBatteryProtectionCurrentChange(val, e) { // 选中某一页
      this.batteryProtectionQuery.pageInfo.pageNum = val
      this.queryBatteryProtectionData()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: '微软雅黑';
}
.searchWarp{
  margin-bottom:10px;
}
</style>
